import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Cross = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4 12L17.7 7.7C18.1 7.3 18.1 6.7 17.7 6.3C17.3 5.9 16.7 5.9 16.3 6.3L12 10.6L7.7 6.3C7.3 5.9 6.7 5.9 6.3 6.3C5.9 6.7 5.9 7.3 6.3 7.7L10.6 12L6.3 16.3C6.1 16.5 6 16.7 6 17C6 17.6 6.4 18 7 18C7.3 18 7.5 17.9 7.7 17.7L12 13.4L16.3 17.7C16.5 17.9 16.7 18 17 18C17.3 18 17.5 17.9 17.7 17.7C18.1 17.3 18.1 16.7 17.7 16.3L13.4 12Z"
      fill="currentColor"
    />
  </svg>
)

export default Cross
